export function switch_api(API_URL) {
  let selectedAPIURL = localStorage.getItem('API')
  selectedAPIURL = selectedAPIURL == "" || selectedAPIURL == null ? `https://ru.api.3d-smile.com/api/v1` : selectedAPIURL 
  return API_URL.replace(`https://ru.api.3d-smile.com/api/v1`, selectedAPIURL)
}


// WEBPACK FOOTER //
// ./src/actions/switch_api.js